export default () => ({
  online: false,
  isSetup: false
})
